import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import ItemList from 'flarum/common/utils/ItemList';
import Separator from 'flarum/common/components/Separator';
import Button from 'flarum/common/components/Button';
import ComposePollGroupPage from '../components/ComposePollGroupPage';
/**
 * The `PollGroupControls` utility constructs a list of buttons for a poll group which
 * perform actions on it.
 */
export default {
  /**
   * Get a list of controls for a poll group.
   */
  controls(pollGroup, context) {
    const items = new ItemList();
    const sections = ['moderation', 'destructive'];
    sections.forEach(section => {
      const controls = this["".concat(section, "Controls")](pollGroup, context).toArray();
      if (controls.length) {
        controls.forEach(item => items.add(item.itemName, item));
        items.add(section + 'Separator', m(Separator, null));
      }
    });
    return items;
  },
  /**
   * Get controls for a poll group pertaining to moderation (e.g. edit).
   */
  moderationControls(pollGroup, context) {
    const items = new ItemList();
    if (pollGroup.canEdit()) {
      items.add('edit', m(Button, {
        icon: "fas fa-pencil-alt",
        onclick: this.editAction.bind(this, pollGroup)
      }, app.translator.trans("fof-polls.forum.poll_groups.controls.edit_label")));
      items.add('addPoll', m(Button, {
        icon: "fas fa-plus",
        onclick: this.addPoll.bind(this, pollGroup)
      }, app.translator.trans("fof-polls.forum.poll_groups.controls.add_poll_label")));
      items.add('view', m(Button, {
        icon: "far fa-arrow-up-right-from-square",
        onclick: () => m.route.set(app.route('fof.polls.groups.view', {
          id: pollGroup.id()
        }))
      }, app.translator.trans("fof-polls.forum.poll_groups.controls.view_label")));
    }
    return items;
  },
  /**
   * Get controls for a poll group which are destructive (e.g. delete).
   * @protected
   */
  destructiveControls(pollGroup, context) {
    const items = new ItemList();
    if (pollGroup.canDelete()) {
      items.add('delete', m(Button, {
        icon: "far fa-trash-alt",
        onclick: this.deleteAction.bind(this, pollGroup)
      }, app.translator.trans("fof-polls.forum.poll_groups.controls.delete_label")));
    }
    return items;
  },
  /**
   * Delete the poll group.
   */
  async deleteAction(pollGroup) {
    if (!confirm(app.translator.trans("fof-polls.forum.poll_groups.controls.delete_confirmation"))) {
      return;
    }
    return pollGroup.delete().then(() => {
      this.showDeletionAlert(pollGroup, 'success');
      if (app.current.matches(ComposePollGroupPage, {
        id: pollGroup.id()
      })) {
        app.history.back();
      } else {
        window.location.reload();
      }
    }).catch(() => this.showDeletionAlert(pollGroup, 'error'));
  },
  /**
   * Show deletion alert of poll group
   */
  showDeletionAlert(pollGroup, type) {
    const message = {
      success: "fof-polls.forum.poll_groups.controls.delete_success_message",
      error: "fof-polls.forum.poll_groups.controls.delete_error_message"
    }[type];
    const content = app.translator.trans(message, {
      pollGroup: pollGroup
    });
    const alertId = app.alerts.show({
      type
    }, content);
    // Errors stay sticky so the user can read them; successes auto-dismiss.
    if (type === 'success') {
      setTimeout(() => app.alerts.dismiss(alertId), 10000);
    }
  },
  /**
   * Edit the poll group.
   */
  editAction(pollGroup) {
    m.route.set(app.route('fof.polls.groups.composer', {
      id: pollGroup.id()
    }));
  },
  /**
   * Add poll to group.
   */
  addPoll(pollGroup) {
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/CreatePollModal', webpackMode: 'lazy-once' */ '../components/CreatePollModal'), {
      onsubmit: function (data) {
        app.store.createRecord('polls').save(_objectSpread(_objectSpread({}, data), {}, {
          relationships: {
            pollGroup: pollGroup
          }
        }), {
          data: {
            include: 'options,myVotes,myVotes.option'
          }
        }).then(poll => {
          var _pollGroup$rawRelatio, _pollGroup$rawRelatio2;
          // @ts-ignore
          (_pollGroup$rawRelatio = pollGroup.rawRelationship('polls')) == null || (_pollGroup$rawRelatio2 = _pollGroup$rawRelatio.push) == null || _pollGroup$rawRelatio2.call(_pollGroup$rawRelatio, {
            type: 'polls',
            id: poll.id()
          });
          m.redraw();
        });
      }
    });
  }
};